import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./axios";
import { createI18n } from "vue-i18n";
import { messages, transformKey } from "./lang/app";
import resumable from "resumablejs";
import "./styles/app.scss";
import "./styles/index.css";
import "./assets/js/underscore-esm-min.js";
import "./assets/css/demo.css";
import "./assets/vendor/libs/node-waves/node-waves.css";
import "./assets/vendor/libs/perfect-scrollbar/perfect-scrollbar.css";
import "./assets/vendor/css/pages/page-auth.css";
import "./assets/vendor/libs/select2/select2.css";
import "./assets/vendor/libs/tagify/tagify.css";
import "./assets/vendor/libs/dropzone/dropzone.css";
import "./assets/vendor/libs/flatpickr/flatpickr.css";
import "./assets/vendor/libs/bootstrap-select/bootstrap-select.css";
import "./assets/vendor/libs/bootstrap-datepicker/bootstrap-datepicker.css";
import "./assets/vendor/libs/bootstrap-daterangepicker/bootstrap-daterangepicker.css";
// import "./assets/vendor/libs/jquery-timepicker/jquery-timepicker.css";
import "./assets/vendor/libs/pickr/pickr-themes.css";
import "./assets/vendor/libs/apex-charts/apex-charts.css";
import "./assets/vendor/libs/swiper/swiper.css";
import "./assets/vendor/libs/datatables-bs5/datatables.bootstrap5.css";
import "./assets/vendor/libs/datatables-responsive-bs5/responsive.bootstrap5.css";
import "./assets/vendor/libs/@form-validation/form-validation.css";
import "./assets/vendor/libs/bs-stepper/bs-stepper.css";
import "./assets/vendor/css/pages/app-logistics-dashboard.css";
import "./assets/vendor/css/pages/cards-advance.css";
import "./assets/vendor/js/helpers.js";
import "./assets/vendor/js/template-customizer.js";
import "./assets/vendor/libs/i18n/i18n.js";
import "./assets/js/main.js";
import "./assets/js/config.js";
import "./assets/vendor/js/bootstrap.js";
// import "./assets/js/front-main.js";
import "./assets/vendor/libs/jquery/jquery.js";
// import "./assets/vendor/libs/select2/select2.js";
import "./assets/vendor/libs/tagify/tagify.js";
import "./assets/vendor/libs/bootstrap-select/bootstrap-select.js";
import "./assets/vendor/libs/moment/moment.js";
import "./assets/vendor/libs/flatpickr/flatpickr.js";
import "./assets/vendor/libs/apex-charts/apexcharts.js";
import "./assets/vendor/libs/swiper/swiper.js";
import "./assets/vendor/js/menu.js";

// import "./assets/vendor/libs/datatables-bs5/datatables-bootstrap5.js";
// import "./assets/vendor/libs/jquery-timepicker/jquery-timepicker.js";
// import "./assets/vendor/libs/pickr/pickr.js";
// import "./assets/vendor/libs/bloodhound/bloodhound.js";
// import "./assets/vendor/libs/cleavejs/cleave.js";
// import "./assets/vendor/libs/cleavejs/cleave-phone.js";
// import "./assets/vendor/libs/@form-validation/popular.js";
// import "./assets/vendor/libs/@form-validation/bootstrap5.js";
// import "./assets/vendor/libs/@form-validation/auto-focus.js";
import "./assets/vendor/libs/bs-stepper/bs-stepper.js";
// import "./assets/js/app-logistics-dashboard.js";
// import "./assets/js/dashboards-analytics.js";
// import "./assets/js/app-invoice-list.js";
import "./assets/vendor/libs/dropzone/dropzone.js";
import { initDropzoneUploaders } from "./assets/js/forms-file-upload.js";
import VueSweetalert2 from "vue-sweetalert2";
import "./assets/vendor/libs/sweetalert2/sweetalert2.css";
import Notifications from "@kyvg/vue3-notification";
import VueGoogleMaps from "@fawmi/vue-google-maps";
import Loading_element from "./components/loading_element.vue";
import InfoButton from "./components/elements/InfoButton.vue";

// import "./assets/js/forms-pickers.js";
// import "./assets/js/forms-selects.js";
// import "./assets/js/forms-tagify.js";
// import "./assets/vendor/libs/typeahead-js/typeahead.css";
// import "./assets/js/forms-typeahead.js";
// import "./assets/js/pages-pricing.js";
// import "./assets/js/modal-create-app.js";
// import "./assets/js/modal-add-new-cc.js";
// import "./assets/js/modal-add-new-address.js";
// import "./assets/js/modal-edit-user.js";
// import "./assets/js/modal-enable-otp.js";
// import "./assets/js/modal-share-project.js";
// import "./assets/js/modal-two-factor-auth.js";
// import "./assets/js/form-wizard-icons.js";

const i18n = createI18n({
  locale: "ar",
  fallbackLocale: "en",
  messages,
  missing: (locale, key) => {
    // Return transformed key if no translation is found
    return transformKey(key);
  },
});
const app = createApp(App);
app.use(store);
app.use(router);
app.use(i18n);
app.use(resumable);
app.use(VueSweetalert2);
app.use(Notifications);
app.component("LoadingElement", Loading_element);
app.component("InfoButton", InfoButton);
app.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDGP7sffMplXgvd1Ot0joHcznXmAYI2UVs",
    v: "weekly",
    autobindAllEvents: true,
  },
});
app.provide("server_url", localStorage.getItem("server"));
app.mount("#app");
